export default __webpack_public_path__ + "static/media/IMG-20240822-WA0013.12ce4aec.jpg";